import { isGE } from '../../Device'

export const MAX_STOPS_GE = 6
export const MAX_STOPS_PE = 1

export const getMaxStops = () => (isGE() ? MAX_STOPS_GE : MAX_STOPS_PE)

export const isStepFilled = step => Boolean(step?.label)
